import React from 'react';
import authRoles from '../../../auth/authRoles';
import EnrollStudents from './EnrollStudents';
import SubmitRoster from './SubmitRoster';

const AdminCreateIncidentReport = React.lazy(() => import('./incident-reports/AdminCreateIncidentReport'));
const IncidentReportView = React.lazy(() => import('./incident-reports/report-view/IncidentReportView'));
const StudentsContainer = React.lazy(() => import('./StudentsContainer'));
const StudentsList = React.lazy(() => import('./new/StudentsList'));

const StudentsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/students/incident-reports/new',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AdminCreateIncidentReport />
				</React.Suspense>
			),
		},
		{
			path: '/students/incident-reports/view/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<IncidentReportView />
				</React.Suspense>
			),
		},
		{
			path: '/students-enroll',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EnrollStudents />
				</React.Suspense>
			),
		},
		{
			path: '/students-submitroster',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SubmitRoster />
				</React.Suspense>
			),
		},
		// the /students route must be last in this list to avoid catching all /students/:slug routes
		{
			path: '/students',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentsContainer />
				</React.Suspense>
			),
			children: [
				{
					path: 'list',
					element: (
						<React.Suspense fallback={<>...</>}>
							<StudentsList />
						</React.Suspense>
					),
				},
				{
					path: 'incident-reports',
					element: (
						<React.Suspense fallback={<>...</>}>
							<StudentsContainer />
						</React.Suspense>
					),
				},
			],
		},
	],
	auth: authRoles.subadmin,
};

export default StudentsConfig;
